'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var Gauge = require('src/common/gauge/')

var resetReasons = require('src/common/app-constants').resetReasons

var rhmTypes = require('src/common/app-constants-rhm').types
var rhmStates = require('src/common/app-constants-rhm').states




/**
 * Status View
 * -----------------------------------------------------------------------------
 */
var StatusView = Marionette.View.extend({
  template: require('./templates/status.html'),
  modelEvents: {
    'change': 'render'
  },
  triggers: {
    'click .js-error-reset': 'error:reset'
  },

  templateContext: function () {
    return {
      getBooleanStateKind: function(value) {
        let label = 'neutral';
        switch (value) {
          case 0:
            label = 'negative';
            break;
          case 1:
            label = 'positive';
            break;
        }
        return label
      },
      getRelayState: function(value) {
        let label = 'waiting';
        switch (value) {
          case 0:
            label = 'disabled';
            break;
          case 1:
            label = 'enabled';
            break;
        }
        return label
      },
      getFailSafeStatus: function () {
        const STATUS = {
          0: 'ok',
          1: 'failsafe',
          2: 'transport mode'
        }

        let getPropertyValue = _.bind(App.TemplateHelpers.getPropertyValue, this)
        let value = getPropertyValue('failsafe','status');
        if (typeof value === 'undefined') {
          return false;
        }
        return STATUS[value];

      },
      isFailSafeStatePositive: function() {
        let getPropertyValue = _.bind(App.TemplateHelpers.getPropertyValue, this)
        let value = getPropertyValue('failsafe','status');


          return (value === 0);
      },
      calcRssi: function (value) {
        value = Math.abs(value)
        var percent = Math.abs((value / 30) * 100)
        if (percent < 0) percent = 0
        if (percent > 100) percent = 100
        return parseInt(percent)
      },
      calcBer: function (value) {
        var percent = 100 / 8 * value
        return parseInt(percent)
      },
      getResetReason: function () {
        return (this.resetReason) ? resetReasons [this.resetReason].label : 'INVALID'
      },
      getFloat: function (value)
      {
        var data =  [((value >> 24) & 0xFF), ((value >> 16) & 0xFF), ((value >> 8) & 0xFF), (value & 0xFF)];

        var buf = new ArrayBuffer(4);
        var view = new DataView(buf);

        data.forEach(function (b, i) {
          view.setUint8(i, b);
        });

        return view.getFloat32(0).toPrecision(3);
      },
      getRhmValueByType: function (type, value) {
        var result = value 
        let state = _.find(rhmStates, {type:type});
        
        if (state) {
          result = (state.states[value]) ? state.states[value].label : result;
        }
        return result
      },
      getLastSeenAt: App.TemplateHelpers.getLastSeenAt,
      formatTimeFromNow: App.TemplateHelpers.formatTimeFromNow,
      hasProperty: App.TemplateHelpers.hasProperty,
      hasSensor: App.TemplateHelpers.hasSensor,
      getPropertyValue: App.TemplateHelpers.getPropertyValue,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getRhmRegisters: App.TemplateHelpers.getRhmRegisters,
      userHasRole: App.TemplateHelpers.userHasRole,
      getSensorValue:function(sensor) {
        let getSensorValue = _.bind(App.TemplateHelpers.getSensorValue, this)

        let value = getSensorValue(sensor);

        if (sensor !== 'novoferm') return value

        // NOVOFERM
        value = value.toUpperCase();

        let data = {
          state:'neutral',
          value:value
        }

        // determine value state
        let valueChar = value.substring(0, 1);
        if (['E','F'].indexOf(valueChar) > -1) {
          data.state = 'negative'
        }

        // label
        switch (value.substring(0, 2)) {
          case 'A0':
            data.value = 'open';
            data.state = 'positive'
            break;
          case 'A1':
            data.value = 'closed';
            data.state = 'positive'
            break;
          case 'A2':
            data.value = 'stopped';
            data.state = 'positive'
            break;
          default:
            data.value = value;
            break;
        }
        return data;  
      },
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel
    }
  }
})
module.exports.StatusView = StatusView

/**
 * Empty View
 * -----------------------------------------------------------------------------
 */
var EmptyView = Marionette.View.extend({
  template: require('./templates/empty.html')
})
module.exports.EmptyView = EmptyView

/**
 * Gauge View
 * -----------------------------------------------------------------------------
 */
var GaugeView = Marionette.View.extend({
  template: require('./templates/gauge.html'),
  initialize: function () {
    this.listenTo(this.model, 'change', function () {})
  },
  updateGauge: function () {
    this.gauge.setValue(this.model.get('value'))
  },
  onRender: function () {
    var definiton = this.model.get('def')
    var gaugeSettings = {
      element: this.el.querySelector('.js-gauge')
    }

    if (definiton.autoRange) {
      gaugeSettings = Object.assign(gaugeSettings, {
        autoRange: true,
        units: definiton.units
      })
    }

    this.gauge = new Gauge(gaugeSettings)
  },
  modelEvents: {
    'change': 'updateGauge'
  },
  templateContext: function () {
    return {
      getBooleanAsString: function (value) {
        return (value) ? 'true' : 'false'
      }
    }
  }
})
module.exports.GaugeView = GaugeView

/**
 * Table View
 * -----------------------------------------------------------------------------
 */
var TableView = Marionette.View.extend({
  template: require('./templates/table.html'),
  initialize: function () {
    this.listenTo(this.model, 'change', function () {})
  },
  // triggers: {
  //   'click .js-register-edit': 'register:set'
  // },

  // error:reset
  events: {
    'click .js-register-edit': 'onRegisterEdit'
  },
  modelEvents: {
    'change': 'render'
  },
  onRegisterEdit: function(event) {
    let registerKey = event.target.getAttribute('data-reg-key')
    let registerValue = event.target.getAttribute('data-reg-value')
    this.trigger('register:set', {key:registerKey,value:registerValue})
  },
  templateContext: function () {
    var self = this
    return {
      getRegKey: function (value) {
        let register = self.model.get('value')[value];
        if (!register) return "-";
        return register.key;
      },
      getLabel: function (value) {
        let register = self.model.get('value')[value];
        if (!register) return "-";
        return register.label;
      },
      getRawValue: function(value) {
        let register = self.model.get('value')[value];
        let regValue = register.value
        return regValue;
      },
      getValue: function (value) {
        let register = self.model.get('value')[value];
        let unit = register.unit;
        if (!register) return "-";

        let regValue = register.value

        // if this is a state value get the label
        let state = _.find(rhmStates, {type:register.type});
        if (state) {
          regValue = (state.states[regValue]) ? state.states[regValue].label : regValue;
        }

        // append the unit
        if (unit) {
          return regValue+ ' ' + unit;
        }
        return regValue;
      }, 
      getBooleanAsString: function (value) {
        return (value) ? 'true' : 'false'
      }
    }
  }
})
module.exports.TableView = TableView

/**
 * Sensors view
 * -----------------------------------------------------------------------------
 */
module.exports.SensorsView = Marionette.CollectionView.extend({
  childView: function(item) {
    switch (item.get('type')) {
      case 'table':
        return TableView;
        break;
      default:
        return GaugeView;

        break;
    }
  },
  emptyView: EmptyView,
  tagName: 'ul',
  className: 'l-device-status-charts__list'
})

/**
 * Tabs list view
 * -----------------------------------------------------------------------------
 */

var TabsItemView = Marionette.View.extend({
  modelEvents: {
    'change': 'render'
  },

  onRender: function () {
    // Get rid of that pesky wrapping-div.
    // Assumes 1 child element present in template.
    this.$el = this.$el.children();
    // Unwrap the element to prevent infinitely 
    // nesting elements during re-render.
    this.$el.unwrap();
    this.setElement(this.$el);
  },
  template: require('./templates/tabTitle.html'),
  triggers: {
    'click': 'tab:select'
  }

})
module.exports.TabsItemView = TabsItemView

module.exports.TabsView = Marionette.CollectionView.extend({
  childView: TabsItemView,
  
  tagName: 'div',
  className: 'l-device-status__tabs-list'
})

/**
 * Layout view
 * -----------------------------------------------------------------------------
 */
module.exports.Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  drawGauges: function () {
    // this.gauge = new Gauge({
    //   element: '.js-gauge__pri-voltage'
    // })
  },


  events: {
    'click .js-control-button': 'onClick'
  },
  onClick: function(ev) {
    this.triggerMethod('control:fetch', {})
  },

  onDomRefresh: function () {
  },
  regions: {
    sensorsRegion: '.sensors-region',
    statusRegion: '.status-region',
    tabsRegion: '.tabs-region'
  },
  modelEvents: {
    'change': 'render'
  },
  templateContext: function () {
    return {
      showFetchButtons:() => {

        // only show fetch buttons if this is an rtm_rhm device
        return this.model.get('type') === 'rtm_rhm' || this.model.get('type') === 'rtm_rhm_mqtt'
      },
      getLastSeenAt: App.TemplateHelpers.getLastSeenAt,
      hasSensor: App.TemplateHelpers.hasSensor,
      getConditionalStr: App.TemplateHelpers.getConditionalStr,
      getSensorValue: App.TemplateHelpers.getSensorValue,
      getDeviceTypeLabel: App.TemplateHelpers.getDeviceTypeLabel
    }
  }
})



// WEBPACK FOOTER //
// ./js/modules/device-status/show/view.js